import React from "react";
import {
  Row,
  Col,
  Avatar,
  Button,
  Space,
  Dropdown,
  Image,
  message,
  Tooltip,
  Modal,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import ShareModalWindow from "./ShareModalWindow";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import kebabIcon from "../assets/images/NewDesign/kebab.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
import {
  DownloadOutlined,
  CloudUploadOutlined,
  DashboardOutlined,
  CopyOutlined,
  ShareAltOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import CompanyAutocomplete from "./CompanyAutocomplete";
import ListTable from "./ListTable";
import config from "../config";
import withRouter from "../withRouter";
import AssignTripStore from "../store/AssignTripStore";
import CompanyStore from "../store/CompanyStore";
import Cookies from "universal-cookie";

class AssignTripList extends React.Component {
  constructor(props, context) {
    super(props);
    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.companyStore = new CompanyStore(this);
    this.onDelete = this.onDelete.bind(this);

    this.assignTripStore = new AssignTripStore();

    // console.log(this.context);

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      openConfirm: false,
      confirmLoading: false,
      companyId: "",
      loadList: 0,
      company_value_label: "",
      openShareModal: false,
      openDeleteModal: false,
    };
    this.cookies = new Cookies();
    this.menuProps = {
      items: [
        {
          label: "Sample Excel",
          key: "1",
          icon: <DownloadOutlined />,
        },
        {
          label: "Upload",
          key: "2",
          icon: <CloudUploadOutlined />,
        },
        {
          label: "Dashboard",
          key: "2",
          icon: <DashboardOutlined />,
        },
      ],
      onClick: () => {},
    };

    this.columns = [
      {
        // title: "Trip Code",
        title: context.translate("_TRIP_CODE_"),
        // width: 150,
        dataIndex: "tripCode",
        key: "tripCode",
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.props.canUpdate("assigntriplist") && this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
        // fixed: "left",
      },
      {
        // title: "Trip Name",
        title: context.translate("_TRIP_NAME_"),
        // width: 150,
        dataIndex: "tripName",
        key: "tripname",
        ellipsis: {
          showTitle: true,
        },
        // fixed: "left",
      },
      {
        // title: "Zone Details",
        title: context.translate("_ZONE_DETAILS_"),
        // width: 150,
        dataIndex: "routeZone",
        key: "zonedetails",
        // fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        // width: 150,
        dataIndex: "vehicleNo",
        key: "vehicleno",
        // fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Seater",
        title: context.translate("_SERATER_"),
        // width: 150,
        dataIndex: "seater",
        key: "seater",
        // fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Available Seats",
        title: context.translate("_AVAILABLE_SEATS_"),
        // width: 150,
        dataIndex: "seats",
        key: "seats",
        // fixed: "left",
        ellipsis: {
          showTitle: true,
        },
      },

      {
        title: context.translate("_ACTION_"),
        dataIndex: "Action",
        // key: "Action",
        fixed: "right",
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        // width: 50,
        render: (_, record) => {
          let tripPoints = record.TripPoints;
          let data = [];
          tripPoints.forEach((val) =>
            data.push(`${val.latitude},${val.longitude}`)
          );

          return (
            <>
              <Space>
                <Tooltip
                  // title="Copy Trip"
                  title={context.translate("_COPY_TRIP_")}
                  placement="bottom"
                  color={config.tooltipColorEdit}
                >
                  <Link
                    to="/assigntripaddnew"
                    onClick={() => this.onCopy(record)}
                  >
                    <CopyOutlined />
                  </Link>
                </Tooltip>

                {this.props.canDelete("assigntriplist") && (
                  <Tooltip
                    title={this.context.translate("_DELETE_RECORD_")}
                    placement="bottom"
                  >
                    <Image
                      src={require("../assets/images/NewDesign/Delete.png")}
                      style={{ cursor: "pointer" ,width:'14px'}}
                      onClick={() =>
                        this.setState({
                          openDeleteModal: true,
                          deleteData: record,
                        })
                      }
                    ></Image>
                  </Tooltip>
                )}
                <Dropdown
                  // overlayClassName="export-dropdown"
                  menu={this.actionColumn}
                  trigger={["click"]}
                  style={{ cursor: "pointer" ,width:'14px'}}
                >
                  <Image
                    src={kebabIcon}
                    onClick={(e) => {
                      e.preventDefault();
                      this.setState({ editData: record });
                    }}
                  ></Image>
                </Dropdown>
              </Space>
            </>
          );
        },
      },
    ];

    this.actionColumn = {
      items: [
        this.props.canUpdate("assigntriplist") && {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
            >
              {" "}
              <Avatar
                style={{ height: "16px", width: "16px", borderRadius: "0px" }}
                src={editIcon}
                onClick={() => this.onEdit(this.state.editData)}
              ></Avatar>
              {context.translate("_FLEET_ROLE_ROLEDETAIL_EDIT_")}
            </div>
          ),
          key: "edit",
        },
        {
          // label: "Excel",
          label: (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => {
                console.log(this.state.editData?.TripPoints);
                let tripPoints = this.state.editData?.TripPoints;
                let data = [];
                tripPoints.forEach((val) =>
                  data.push(`${val.latitude},${val.longitude}`)
                );
                this.setState({ openShareModal: data });
              }}
            >
              {" "}
              <Tooltip
                // title="Share Location"
                title={context.translate("_SHARE_LOCATION_")}
                placement="bottom"
                color={config.tooltipColorEdit}
              >
                <ShareAltOutlined />
              </Tooltip>
              {context.translate("_SHARE_LOCATION_")}
            </div>
          ),
          key: "shareLocation",
        },
      ],
    };
  }
  async componentDidMount() {
    this.setState({ pageSize: 50 });
    // const beforeEditCompanyId = await this.context.viewStateStore
    //   .assignTripObject.companyId;

    // await this.assignTripStore.loadData({
    //   offset: (this.state.currentPage - 1) * this.state.pageSize,
    //   limit: this.state.pageSize,
    //   companyId: beforeEditCompanyId,
    // });

    // this.setState({ companyId: beforeEditCompanyId });
    // const singleData = await this.companyStore.getCompanyDataById(
    //   this.context.viewStateStore.assignTripObject.companyId
    // );
    // await this.setState({ loadList: 1 }); //need to reload data
    // await this.setState({ company_value_label: singleData });
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      await this.setState({ userId: this.props.getUserData().userId });
      await this.assignTripStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
      });
      await this.setState({ loadList: 1 });
    } else if (this.cookies.get("companyId2")) {
      await this.setState({ companyId: this.cookies.get("companyId2") });

      await this.assignTripStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,
        companyId: this.state.companyId,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        this.state.companyId
      );
      await this.setState({ company_value_label: singleData });
      await this.setState({ loadList: 1 });
    }
  }

  async componentWillUnmount() {
    this.cookies.remove("companyId2");
  }
  onEdit = async (record) => {
    console.log(record);
    const stId = record.stId;
    await this.context.viewStateStore.setAssignTripStates({
      companyId: record.companyId,
    });
    if (stId) {
      this.props.navigate("/assigntripaddnew/" + stId);
    }
  };

  onCopy = async (record) => {
    console.log(record);
    const stId = record.stId + "copy";
    await this.context.viewStateStore.setAssignTripStates({
      companyId: record.companyId,
    });
    if (stId) {
      this.props.navigate("/assigntripaddnew/" + stId);
    }
  };
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }

  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    console.log(comp);
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    console.log(singleData);
    await this.setState({ company_value_label: singleData });

    await this.setState({ loadList: 1 });
    await this.handleSearch();
  }

  async handleSearch() {
    this.setState({ loading: true });
    await this.assignTripStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      searchField: this.state.searchField,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }
  async onDelete(record) {
    console.log(record);
    const response = await this.assignTripStore.deleteTrip({
      stId: record.stId,
    });
    // console.log(response.data.success)
    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  }
  refreshList = async () => {
    if (this.state.companyId) {
      this.setState({ loading: true });
      await this.assignTripStore.loadData({
        offset: 0,
        limit: 50,
        companyId: this.state.companyId,
      });
      this.setState({ loading: false, currentPage: 1 });
    }
  };
  handleClear = async () => {
    await this.setState({
      company_value_label: null,
      companyId: "",
    });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  value={
                    this.state.company_value_label
                      ? this.state.company_value_label
                      : null
                  }
                  // allowClear={true}
                  style={{ width: 200 }}
                  allowClear={true}
                  onClear={this.handleClear}
                />
              </Space>
            </Col>

            <Col span={6}>
              <Space
                style={{
                  float:
                    this.context.locale.direction === "ltr" ? "right" : "left",
                }}
              >
                <Tooltip
                  title={this.context.translate("_REFRESH_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: 18,
                      // marginInlineEnd: "40px",
                      alignItems: "center",
                      cursor: "pointer",
                    }}
                    src={refreshIcon}
                    onClick={() => this.refreshList()}
                  ></Image>
                </Tooltip>

                {this.props.canCreate("assigntriplist") && (
                  <Button
                    className="addButtonClass"
                    onClick={() => this.props.navigate("/assigntripaddnew")}
                  >
                    <Image
                      style={{ marginInlineEnd: "5px", width: 13 }}
                      src={require("../assets/images/NewDesign/plus (Stroke).png")}
                    ></Image>
                    {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
                  </Button>
                )}
              </Space>
            </Col>
          </Row>

          <ListTable
            current={this.state.currentPage}
            total={this.assignTripStore?.total}
            columns={this.columns}
            dataSource={this.assignTripStore?.tripDataArray}
            loading={this.assignTripStore?.loading}
            onChange={this.handleTableChange}
          />
        </div>

        {this.state.openShareModal && (
          <ShareModalWindow
            shareLink={this.state.openShareModal}
            shareModalCloseFunc={(resp) =>
              this.setState({ openShareModal: resp })
            }
            shareModalVisible={this.state.openShareModal}
          />
        )}

        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
AssignTripList.contextType = StoreContext;
export default observer(withRouter(AssignTripList));
